import { createSlice } from "@reduxjs/toolkit";

const posItemsSlice = createSlice({
  name: "posItems",
  initialState: [],
  reducers: {
    updateItemById: (state, action) => {
      const { ItemC, updatedItem } = action.payload;
      const index = state.findIndex((item) => item.ItemC === ItemC);
      if (index !== -1) {
        state[index] = { ...state[index], ...updatedItem };
      }
    },

    deleteItemById: (state, action) => {
      return state.filter((item) => item.ItemC !== action.payload);
    },

    resetItems: () => {
      return [];
    },
    setAllProducts: (state, action) => {
      return action.payload;
    },
  },
});

export const { updateItemById, deleteItemById, resetItems, setAllProducts } =
  posItemsSlice.actions;
export default posItemsSlice.reducer;
